import { NgModule, Inject } from '@angular/core';
import { filter } from 'rxjs/operators';
import * as Rollbar from 'rollbar';

import { UserEntity } from '../user-base';
import { rollbarErrorProvider, RollbarService } from './rollbar-lib.service';

@NgModule({
  providers: [ ...rollbarErrorProvider ]
})
export class RollbarLibModule {
  constructor(
    private _userEntity: UserEntity,
    @Inject(RollbarService)
    private _rollbar: Rollbar
  ) {
    this._userEntity
      .activeClientUser$
      .pipe(filter((d) => !!d))
      .subscribe(({ user }) => {
        this._rollbar.configure({
          payload: {
            person: {
              id: user.id,
              username: user.fullName,
              email: user.email
            }
          },
          checkIgnore: function(isUncaught: boolean, args: Rollbar.LogArgument[], payload: Rollbar.Dictionary) {

            const typedPayload = payload as {
              data?: {
                body?: {
                  message?: {
                    body?: string;
                  };
                  trace?: {
                    frames?: Array<{
                      filename?: string;
                    }>;
                  };
                };
              };
            };
            const msg = typedPayload.data?.body?.message?.body ?? '';

            /**
             * Ignore errors containing a specific substring. Typical problematic pattern in Zerops:
             * Error: Error retrieving icon :github! undefined
             * This error is caused by a third-party crawlers and does not affect our application, but it is
             * reported to Rollbar as an error. The reason is that some part of a page on app.zerops.io
             * is called too early and separately, when the application is not fully initialized.
             */
            if (msg.includes('Error retrieving icon')) return true;

            /**
             * Ignore errors matching a regex.
             */
            // if (/^IconError:.*undefined$/.test(msg)) return true;

            /**
             * Ignore errors from a specific file.
             */
            // const filename = typedPayload?.data?.body?.trace?.frames?.[0]?.filename ?? '';
            // if (filename.includes('any relevant pattern in name')) return true;

            /**
             * Allow everything else.
             */
            return false;

          }
        });
      });
  }
}
